/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Arkadium/GameEngine/Core/EngineManagers',['absolute/audiomanager', 'absolute/musicmanager'], function (AudioManager, MusicManager) {
    var EngineManagers = {

        game: null,

        ui: null,

        startTime: 0,

        totalGameTime: 0,

        elapsedGameTime: 0,

        Init: function (game, ui) {
            this.game = game;
            this.ui = ui;
            this.startTime = Date.now();
            this.totalGameTime = 0;
            this.elapsedGameTime = 0;
        },

        Sounds: {
            PlaySound: function (sound) {
                AudioManager.playSound(sound);
            },

            StopSound: function (sound) {
                AudioManager.stopSound(sound);
            },

            UpdateSoundState: function(sfxEnabled, musicEnabled) {

                sfxEnabled = sfxEnabled !== -1 ? sfxEnabled : AudioManager.isSfxEnabled();
                musicEnabled = musicEnabled !== -1 ? musicEnabled : !MusicManager.isMuted();

                MusicManager.setMuted(!musicEnabled);
                AudioManager.setSfxEnabled(sfxEnabled);

            }
        },

        Display: {

        },

        Time: {
            Update: function (dT) {
                if (!isNaN(dT)) {
                    EngineManagers.elapsedGameTime = dT;
                    EngineManagers.totalGameTime += dT;
                }
            },

            ElapsedGameTime: {

            },

            TotalGameTime: {

            }
        }
    };

     Object.defineProperty(EngineManagers, "UI", {
        get: function () {
            return EngineManagers.ui;
        }
    });

    Object.defineProperty(EngineManagers.Time.ElapsedGameTime, "TotalSeconds", {
        get: function () {
            return EngineManagers.elapsedGameTime / 1000;
        }
    });

    Object.defineProperty(EngineManagers.Time.ElapsedGameTime, "TotalMilliseconds", {
        get: function () {
            return EngineManagers.elapsedGameTime;
        }
    });

    Object.defineProperty(EngineManagers.Time.ElapsedGameTime, "Milliseconds", {
        get: function () {
            return EngineManagers.elapsedGameTime;
        }
    });

    Object.defineProperty(EngineManagers.Time.TotalGameTime, "TotalSeconds", {
        get: function () {
            return EngineManagers.totalGameTime / 1000;
        }
    });

    Object.defineProperty(EngineManagers.Time.TotalGameTime, "TotalMilliseconds", {
        get: function () {
            return EngineManagers.totalGameTime;
        }
    });

    Object.defineProperty(EngineManagers.Time.TotalGameTime, "Milliseconds", {
        get: function () {
            return EngineManagers.totalGameTime;
        }
    });


    Object.defineProperty(EngineManagers.Display, "Width", {
        get: function () {
            if (EngineManagers.ui) {
                return EngineManagers.ui.width;
            }
            return 0;
        }
    });

    Object.defineProperty(EngineManagers.Display, "Height", {
        get: function () {
            if (EngineManagers.ui) {
                return EngineManagers.ui.height;
            }
            return 0;
        }
    });

    return EngineManagers;
});
